import { ClientSideTable } from 'Presentation/Components/Table'
import { KTSVG } from '_metronic/helpers'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import moment from 'moment'

interface Props {
  onClickAdd: () => void
  data: any[]
  projectData: any
  projectMachines?: any[]
  columns: any[]
}

const ShippingRequest: React.FC<Props> = ({ projectData, projectMachines = [], columns, data }) => {
  const navigate = useNavigate()
  const { profile } = useAuthStore(state => ({ profile: state.profile }), shallow)
  const userRoleId = profile?.roleId || 0
  const isHideScanReceivePile = [2, 7, 8].includes(userRoleId)
  const isHideCreateShippingRequest = [2, 7, 8, 21].includes(userRoleId)

  const onStartScan = () => {
    navigate(`/project/${projectData?.id}/pile-scan`)
  }

  const onCreateShippingRequest = () => {
    navigate(
      `/shipping-request/create?saleOrderId=${projectData.saleOrder.id}&projectId=${projectData.id}`
    )
  }

  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title'></div>
        <div className='card-toolbar'>
          {!isHideScanReceivePile && (
            <button type='button' className='btn btn-sm btn-primary me-2' onClick={onStartScan}>
              <KTSVG
                path='/media/icons/duotune/arrows/arr075.svg'
                svgClassName='svg-icon-1x svg-primary'
              />
              <span>สแกนรับเสา</span>
            </button>
          )}
          {projectData.saleOrder && !isHideCreateShippingRequest && (
            <button
              type='button'
              className='btn btn-sm btn-primary'
              onClick={onCreateShippingRequest}>
              <KTSVG
                path='/media/icons/duotune/arrows/arr017.svg'
                svgClassName='svg-icon-1 svg-primary'
              />
              <span>สร้างคำร้อง</span>
            </button>
          )}
        </div>
      </div>

      <div className='card-body px-0'>
        <ClientSideTable isGrey pagination columns={columns} data={data} items_per_page={10} />
      </div>
    </div>
  )
}

export default ShippingRequest
